
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'MultisidebarActions'
})
export default class MultisidebarActions extends Vue {}
